export default __webpack_public_path__ + "static/media/Rachel Stonestreet.bed70eed.jpg";